module.exports = {
	"textures": [
		{
			"image": "historyMisc",
			"format": "RGBA8888",
			"size": {
				"w": 58,
				"h": 58
			},
			"scale": 1,
			"frames": [
				{
					"filename": "historyMarker.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 54,
						"h": 54
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 54,
						"h": 54
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 54,
						"h": 54
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};